import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'customDateFormat',
    standalone: false
})
export class CustomDateFormatPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }

    const dateParts = value.split('-');

    // Ensure the date has the required format "yyyy-MM-dd"
    if (dateParts.length === 3) {
      const year = dateParts[0];
      const month = dateParts[1];
      const day = dateParts[2].split(' ')[0]; // Extract day part, remove time if present

      // Create the formatted date string in the "dd.MM.yyyy" format
      return `${day}.${month}.${year}`;
    }

    return value; // Return the original value if the format is not as expected
  }
}